import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    viewBox={'0 0 20 20'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      stroke={props.fill || '#fff'}
      strokeWidth={2}
      d="M1 1h3v3H1zM8 1h11v3H8zM1 8h3v3H1zM8 8h11v3H8zM1 16h3v3H1zM8 16h11v3H8z"
    />
  </Svg>
);
export default SvgComponent;
